$(document).ready(function () {
    var page = $('body').attr('p') || '';
    if (page.indexOf('organizer_crm_') !== 0 && page !== 'organizer_partner_crm') return;

    if ($.fn.select2) {
        $('.select2').each(function () {
            var select = $(this);
            select.select2({
                theme: 'bootstrap4',
                width: '100%',
                placeholder: select.data('placeholder') || '',
                allowClear: !select.prop('required')
            });
        });
    }

    $(document).on('change', '#crm-contract-template', function () {
        var option = this.options[this.selectedIndex];
        var text = option ? option.getAttribute('data-text') || '' : '';
        var attachments = option ? parseJsonAttribute($(option), 'data-attachments') : [];

        if (window.tinymce && tinymce.get('crm-contract-text')) {
            tinymce.get('crm-contract-text').setContent(text);
        } else {
            $('#crm-contract-text').val(text);
        }

        var preview = $('#crm-template-attachments');
        $('#crm-template-excluded-attachments').empty();
        if (!option || !option.value) {
            preview.addClass('d-none').find('ul').empty();
            return;
        }

        var form = $('.crm-contract-form');
        var list = preview.removeClass('d-none').find('ul').empty();
        if (attachments.length) {
            attachments.forEach(function (attachment) {
                var item = $('<li>').attr('data-file', attachment.file).appendTo(list);
                $('<a>').attr({href: attachment.url, target: '_blank', rel: 'noopener'}).text(attachment.name).appendTo(item);
                var removeLabel = translated(form, 'remove-template-attachment');
                $('<button>').attr({type: 'button', 'aria-label': removeLabel + ': ' + attachment.name})
                    .addClass('btn btn-sm btn-link text-danger crm-remove-template-attachment').text(removeLabel).appendTo(item);
                if (attachment.description) {
                    $('<div>').addClass('text-muted small').text(attachment.description).appendTo(item);
                }
            });
        } else {
            $('<li>').addClass('text-muted').text(translated(form, 'template-no-attachments')).appendTo(list);
        }
    });

    $(document).on('click', '.crm-remove-template-attachment', function () {
        var item = $(this).closest('li');
        var sibling = item.next('li').length ? item.next('li') : item.prev('li');
        $('<input>').attr({type: 'hidden', name: 'excluded_template_attachments[]', value: item.attr('data-file')})
            .appendTo('#crm-template-excluded-attachments');
        item.remove();

        if (sibling.length) {
            sibling.find('.crm-remove-template-attachment').trigger('focus');
            return;
        }
        $('#crm-template-attachments').addClass('d-none');
        $('#crm-contract-template').next('.select2').find('.select2-selection').trigger('focus');
    });

    $(document).on('click', '#crm-add-attachment', function () {
        var rows = $('#crm-attachment-rows');
        var row = rows.children('.crm-attachment-row').first().clone();
        row.find('input, textarea').val('');
        rows.append(row);
    });

    $(document).on('click', '.crm-remove-attachment', function () {
        var rows = $('#crm-attachment-rows');
        if (rows.children('.crm-attachment-row').length > 1) {
            $(this).closest('.crm-attachment-row').remove();
            return;
        }
        rows.find('input, textarea').val('');
    });

    $(document).on('submit', '.crm-contract-form, .crm-email-form', function (event) {
        var form = $(this);
        if (form.data('submitted')) {
            event.preventDefault();
            return;
        }
        form.data('submitted', true);
        form.find('button[type="submit"]').prop('disabled', true).text(translated(form, 'sending'));
    });

    function updateEmailRecipients() {
        var mode = $('input[name="recipient_mode"]:checked').val();
        $('.crm-recipient-mode-card').removeClass('is-active').has('input:checked').addClass('is-active');
        $('.crm-recipient-options').each(function () {
            var active = $(this).data('mode') === mode;
            $(this).toggleClass('d-none', !active).find('select').prop('required', active);
        });

        var summary = $('#crm-recipient-summary');
        if (!summary.length) return;
        var recipients = [];
        var context = '';
        if (mode === 'all') {
            recipients = parseJsonAttribute(summary, 'data-all-partners');
        } else if (mode === 'categories') {
            var categoryNames = $('#crm-email-categories option:selected').map(function () {
                return $(this).attr('data-name') || '';
            }).get();
            recipients = selectedPartners($('#crm-email-category-partners'));
            if (!categoryNames.length && !recipients.length) {
                summary.find('p').text(translated(summary, 'choose-categories'));
                return;
            }
            if (categoryNames.length) {
                context = interpolate(translated(summary, 'selected-categories'), {categories: categoryNames.join(', ')}) + ' ';
            }
        } else {
            recipients = selectedPartners($('#crm-email-partners'));
            if (!recipients.length) {
                summary.find('p').text(translated(summary, 'choose-partners'));
                return;
            }
        }

        var unique = {};
        recipients.forEach(function (partner) {
            var key = partner.id || String(partner.email).toLowerCase();
            if (key) unique[key] = partner;
        });
        recipients = Object.keys(unique).map(function (key) { return unique[key]; });
        if (!recipients.length) {
            summary.find('p').text(context + translated(summary, 'no-active-partners'));
            return;
        }
        var visible = recipients.slice(0, 5).map(function (partner) {
            return partner.name + (partner.email ? ' <' + partner.email + '>' : '');
        });
        var more = recipients.length > visible.length
            ? ' ' + interpolate(translated(summary, 'more'), {count: recipients.length - visible.length})
            : '';
        var recipientText = translated(summary, recipients.length === 1 ? 'recipient-one' : 'recipient-many');
        summary.find('p').text(context + interpolate(recipientText, {count: recipients.length, list: visible.join(', '), more: more}));
    }

    function selectedPartners(select) {
        return select.find('option:selected').map(function () {
            return {id: parseInt(this.value, 10), name: $(this).attr('data-name') || '', email: $(this).attr('data-email') || ''};
        }).get();
    }

    function categoryPartnerIds() {
        var ids = {};
        $('#crm-email-categories option:selected').each(function () {
            parseJsonAttribute($(this), 'data-partners').forEach(function (partner) {
                ids[partner.id] = true;
            });
        });
        return ids;
    }

    var previousCategoryPartnerIds = categoryPartnerIds();
    function syncCategoryRecipients() {
        var currentIds = categoryPartnerIds();
        $('#crm-email-category-partners option').each(function () {
            if (currentIds[this.value] && !previousCategoryPartnerIds[this.value]) this.selected = true;
            else if (!currentIds[this.value] && previousCategoryPartnerIds[this.value]) this.selected = false;
        });
        previousCategoryPartnerIds = currentIds;
        $('#crm-email-category-partners').trigger('change');
    }

    $(document).on('change', '#crm-email-categories', syncCategoryRecipients);
    $(document).on('change', 'input[name="recipient_mode"], #crm-email-category-partners, #crm-email-partners', updateEmailRecipients);
    updateEmailRecipients();

    if ($('.tinymce').length && typeof tinymce !== 'undefined') {
        var darkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
        var settings = {
            selector: '.tinymce',
            content_style: darkMode
                ? 'html,body{background:#323232!important;color:#eee!important;} .mce-content-body{font-size:14px;line-height:1.6;padding:16px;} a{color:#a8c9ff;}'
                : '.mce-content-body{font-size:14px;line-height:1.6;padding:16px;}',
            plugins: 'table,code,hr,link,searchreplace,visualblocks,fullscreen,lists',
            toolbar: 'formatselect | bold italic | link | alignleft aligncenter alignright | numlist bullist | removeformat',
            convert_urls: false,
            relative_urls: false,
            branding: false,
            content_css: '/public/static/' + $('body').data('vendor-css')
        };
        if (darkMode) settings.skin = 'oxide-dark';
        if ($('body').attr('lang') === 'no') settings.language = 'nb_NO';
        tinymce.init(settings);
    }
});
    function translated(element, name, fallback) {
        return element.attr('data-' + name) || fallback || '';
    }

    function parseJsonAttribute(element, name) {
        try {
            var value = JSON.parse(element.attr(name) || '[]');
            return Array.isArray(value) ? value : [];
        } catch (error) {
            // Invalid preview metadata only affects the UI; the server still validates the submitted data.
            return [];
        }
    }

    function interpolate(template, values) {
        Object.keys(values).forEach(function (key) {
            template = template.split('%' + key + '%').join(values[key]);
        });
        return template;
    }
